export const COUNTRY_TRANSLATIONS: Record<string, string> = {
  'estados unidos': 'United States',
  'usa': 'United States',
  'reino unido': 'United Kingdom',
  'sudáfrica': 'South Africa',
  'sudafrica': 'South Africa',
  'nueva zelanda': 'New Zealand',
  'nueva zelandia': 'New Zealand',
  'tailandia': 'Thailand',
  'filipinas': 'Philippines',
  'taiwán': 'Taiwan',
  'taiwan': 'Taiwan',
  'corea del sur': 'South Korea',
  'corea del norte': 'North Korea',
  'emiratos árabes': 'United Arab Emirates',
  'emiratos arabes': 'United Arab Emirates',
  'república dominicana': 'Dominica',
  'republica dominicana': 'Dominica',
  'república del congo': 'Republic of the Congo',
};
